import React from 'react';
import { useIntl } from 'react-intl';

export function injectIntl(Component) {
  const Wrapped = React.forwardRef((props, ref) => {
    const intl = useIntl();
    return <Component {...props} intl={intl} ref={ref} />;
  });
  Wrapped.displayName = `injectIntl(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
}

export default injectIntl;
